var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.044,
    height: 24.346,
    viewBox: "0 0 16.044 24.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10952",
    "data-name": "Group 10952",
    transform: "translate(-2347 -18210)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6031",
    "data-name": "Path 6031",
    d: "M165.48,0h6.11V24.346h-6.11Z",
    transform: "translate(2181.52 18210)",
    fill: "#203662",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6032",
    "data-name": "Path 6032",
    d: "M393.98,0h6.11V24.346h-6.11Z",
    transform: "translate(1962.954 18210)",
    fill: "#203662",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseicon);
export default __webpack_public_path__ + "static/media/Pauseicon.375008b1772331b885364d87f428d128.svg";
export { ForwardRef as ReactComponent };